import React from 'react'
import {HistoriquePrixArgus} from './HistoriquePrixArgus'

interface tarifProps {
  dataPrix?: any
}

const PrixArgImport = ({dataPrix}: tarifProps) => {
  let dataHistory: any = {}
  let variationArgusIm = ''
  let variationArgusIm1 = ''
  let variationArgusIm2 = ''
  let variationArgusIm3 = ''
  let prixArgusActuel = 0
  let prixArgusPrec1 = 0
  let prixArgusPrec2 = 0
  let prixArgusPrec3 = 0
  const prixArgusImporter = dataPrix?.nouveauPrix

  if (dataPrix?.history) {
    dataHistory = JSON.parse(dataPrix?.history)
    let prixByMonth = HistoriquePrixArgus(dataHistory) // fonction qui retourne les prix argus

    prixArgusActuel = Number(prixByMonth.prixM) // prix argus du mois actuel
    prixArgusPrec1 = Number(prixByMonth.prixM1) // prix argus du mois m-1
    prixArgusPrec2 = Number(prixByMonth.prixM2) // prix argus du mois m-2
    prixArgusPrec3 = Number(prixByMonth.prixM3) // prix argus du mois m-3

    //variation du prix argus actuel et le prix importer
    if (prixArgusActuel) {
      if (prixArgusActuel > prixArgusImporter) {
        variationArgusIm = 'baisse'
      } else if (prixArgusActuel < prixArgusImporter) {
        variationArgusIm = 'hausse'
      } else {
        variationArgusIm = 'stable'
      }
    }

    //variation du prix argus actuel et le prix argus du mois m-1
    if (prixArgusActuel && prixArgusPrec1) {
      if (prixArgusActuel > prixArgusPrec1) {
        variationArgusIm1 = 'hausse'
      } else if (prixArgusActuel < prixArgusPrec1) {
        variationArgusIm1 = 'baisse'
      } else {
        variationArgusIm1 = 'stable'
      }
    }

    //variation du prix argus du mois m-1 et le prix argus du mois m-2
    if (prixArgusPrec1 && prixArgusPrec2) {
      if (prixArgusPrec1 > prixArgusPrec2) {
        variationArgusIm2 = 'hausse'
      } else if (prixArgusPrec1 < prixArgusPrec2) {
        variationArgusIm2 = 'baisse'
      } else {
        variationArgusIm2 = 'stable'
      }
    }

    //variation du prix argus du mois m-2 et le prix argus du mois m-3
    if (prixArgusPrec2 && prixArgusPrec3) {
      if (prixArgusPrec2 > prixArgusPrec3) {
        variationArgusIm3 = 'hausse'
      } else if (prixArgusPrec2 < prixArgusPrec3) {
        variationArgusIm3 = 'baisse'
      } else {
        variationArgusIm3 = 'stable'
      }
    }
  }

  return (
    <div className='d-flex mt-5 gap-5 h-200px'>
      <div className='col-lg-3 d-flex justify-content-center align-items-center border-1 border border-secondary rounded-1'>
        <div className='d-flex gap-5'>
          <div>
            <span>Prix Argus m-2</span>
            <div className='border border-1 border-secondary h-50px text-center rounded-1 d-flex justify-content-center align-items-center mb-2'>
              {prixArgusPrec2.toFixed(2)} €
            </div>
            {variationArgusIm3 === 'hausse' && (
              <span className='text-center d-flex justify-content-center align-items-center'>
                <i className='bi bi-arrow-up-right fs-1' style={{color: 'orange'}}></i>
              </span>
            )}
            {variationArgusIm3 === 'baisse' && (
              <span className='text-center d-flex justify-content-center align-items-center'>
                <i className='bi bi-arrow-down-right fs-1' style={{color: 'red'}}></i>
              </span>
            )}
            {variationArgusIm3 === 'stable' && (
              <span className='text-center d-flex justify-content-center align-items-center'>
                <i className='bi bi-arrow-right fs-1' style={{color: 'green'}}></i>
              </span>
            )}
          </div>
          <div>
            <span>Prix Argus m-1</span>
            <div className='border border-1 border-secondary h-50px text-center rounded-1 d-flex justify-content-center align-items-center mb-2'>
              {prixArgusPrec1.toFixed(2)} €
            </div>
            {variationArgusIm2 === 'hausse' && (
              <span className='text-center d-flex justify-content-center align-items-center'>
                <i className='bi bi-arrow-up-right fs-1' style={{color: 'orange'}}></i>
              </span>
            )}
            {variationArgusIm2 === 'baisse' && (
              <span className='text-center d-flex justify-content-center align-items-center'>
                <i className='bi bi-arrow-down-right fs-1' style={{color: 'red'}}></i>
              </span>
            )}
            {variationArgusIm2 === 'stable' && (
              <span className='text-center d-flex justify-content-center align-items-center'>
                <i className='bi bi-arrow-right fs-1' style={{color: 'green'}}></i>
              </span>
            )}
          </div>
        </div>
      </div>
      <div className='col-lg-8 align-items-center justify-content-between d-flex'>
        <div>
          <span>Prix Argus actuels</span>
          <div className='border border-1 border-secondary h-50px text-center rounded-1 d-flex justify-content-center align-items-center mb-2'>
            {prixArgusActuel.toFixed(2)} €
          </div>
          {variationArgusIm1 === 'hausse' && (
            <span className='text-center d-flex justify-content-center align-items-center'>
              <i className='bi bi-arrow-up-right fs-1' style={{color: 'orange'}}></i>
            </span>
          )}
          {variationArgusIm1 === 'baisse' && (
            <span className='text-center d-flex justify-content-center align-items-center'>
              <i className='bi bi-arrow-down-right fs-1' style={{color: 'red'}}></i>
            </span>
          )}
          {variationArgusIm1 === 'stable' && (
            <span className='text-center d-flex justify-content-center align-items-center'>
              <i className='bi bi-arrow-right fs-1' style={{color: 'green'}}></i>
            </span>
          )}
        </div>

        <div>
          <span>Prix importés</span>
          <div className='border border-1 border-secondary h-50px text-center rounded-1 d-flex bg-light-primary justify-content-center align-items-center mb-2'>
            {prixArgusImporter.toFixed(2)} €
          </div>
          {variationArgusIm === 'hausse' && (
            <span className='text-center d-flex justify-content-center align-items-center'>
              <i className='bi bi-arrow-up-right fs-1' style={{color: 'orange'}}></i>
            </span>
          )}
          {variationArgusIm === 'baisse' && (
            <span className='text-center d-flex justify-content-center align-items-center'>
              <i className='bi bi-arrow-down-right fs-1' style={{color: 'red'}}></i>
            </span>
          )}
          {variationArgusIm === 'stable' && (
            <span className='text-center d-flex justify-content-center align-items-center'>
              <i className='bi bi-arrow-right fs-1' style={{color: 'green'}}></i>
            </span>
          )}
        </div>
        <div>
          <span></span>
          <div>
            <button className='btn btn-secondary text-white'>Importé</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export {PrixArgImport}
